import GlobalData from "@/GlobalData";
import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { defineStore, acceptHMRUpdate } from "pinia";
import { useRouter } from "vue-router";

export const useContentStore = defineStore("content", {
  state: () => ({
    totalRecords: 0 as Number,
    contents: [] as Array<api.Batch>,
    loading: false,
    currentContent: {} as api.Batch,
    currentTransfer: {} as api.ContentsListTransfersRequest,
    currentPackageForReingest: {} as api.ContentsListReingestRequestsRequest,
    currentPackageForDissemination:
      {} as api.ContentsListDisseminationRequestsRequest,
    currentPackageStatusUpdates:
      {} as api.ContentsListPackageStatusUpdatesRequest,
    currentWorkflow: {} as api.ContentsListWorkflowDefinitionsRequest,
    currentFileFormat: {} as api.ContentsListFileformatCategoryChangesRequest,
    currentUnknownContent: {} as api.Batch,
    currentTransferException: {} as api.ContentsListTransferExceptionsRequest,
    body: {
      definition_file: "" as String,
    },
    definitionfile: "" as string,
    currentPage: 1 as Number,
    currentStartingAfter: "" as String | undefined,
    currentContentId: 0 as Number,
    currentFilters: [
      { fieldName: "id", filterText: "" },
      { fieldName: "transferring_agency", filterText: "" },
      {
        fieldName: "status",
        filterText: "",
      },
      { fieldName: "content_type", filterText: "" },
      { fieldName: "status_updated_at", filterText: "" },
    ] as Array<any>,

    currentPerPage: 20 as any,
  }),
  getters: {},
  actions: {
    async fetchContents(
      perPage: number,
      sort: string,
      filters: Array<any>,

      page: number,
      currentContentId: number
    ) {
      // this.$reset();
      const authStore = useAuthenticationStore();
      const router = useRouter();
      this.loading = true;
      if (
        authStore.userRole != 1 &&
        authStore.userRole != 2 &&
        authStore.userRole != 3 &&
        authStore.userRole != 0 &&
        authStore.userRole != 5
      ) {
        GlobalData.getInstance().errorMessage.setErrorStatus(403);
        router.push({ name: "error" });
      }
      // this.currentPage = page;
      this.currentContentId = currentContentId;
      this.currentFilters = filters;
      client.content
        .contentsListBatches({
          number: filters[0].filterText,
          transferringAgency: filters[1].filterText,
          status: filters[2].filterText,
          contentType: filters[3].filterText,
          statusUpdatedAt: filters[4].filterText,
          ordering: sort as api.ContentsListBatchesOrderingEnum,
          limit: 1000,
        })
        .then((payload) => {
          this.contents = payload.items;
          this.totalRecords = payload.totalCount;
          // this.currentStartingAfter = String(payload.items[0].id + 1);
        })
        .finally(() => {
          this.loading = false;
          // console.log("123", this.currentContentId);
          if (this.currentContentId == 0) {
            this.currentContent = this.contents[Number(this.currentContentId)];
          }
        })
        .catch((error) => {
          //this.loading = false;
          return error;
        });
    },
    fetchCurrent(row: any, pageIndex: any) {
      this.$reset;
      this.currentContent = row;
      this.currentContentId = pageIndex;
      this.loading = false;
    },

    async fetchPackageForReingest(batchId: number) {
      this.loading = true;
      client.content
        .contentsListReingestRequests({ batchId })
        .then((payload) => {
          for (let i = 0; i < payload.items.length; i++) {
            if (payload.items[i].batchId == batchId) {
              this.currentPackageForReingest = payload.items[i];
            }
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },
    async fetchPackageForDissemination(batchId: number) {
      this.loading = true;
      client.content
        .contentsListDisseminationRequests({ batchId })
        .then((payload) => {
          for (let i = 0; i < payload.items.length; i++) {
            if (payload.items[i].batchId == batchId) {
              this.currentPackageForDissemination = payload.items[i];
            }
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },
    async fetchPackageStatusUpdates(batchId: string) {
      this.loading = true;
      client.content
        .contentsListPackageStatusUpdates({ id: batchId })
        .then((payload) => {
          this.currentPackageStatusUpdates = payload.items[0];
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },
    async fetchNewWorkflowDefinition(batchId: number) {
      this.loading = true;
      client.content
        .contentsListWorkflowDefinitions({ batchId })
        .then((payload) => {
          for (let i = 0; i < payload.items.length; i++) {
            if (payload.items[i].batchId == batchId) {
              this.currentWorkflow = payload.items[i];
            }
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },
    async fetchFileFormatCategoryChanges(batchId: number) {
      this.loading = true;
      client.content
        .contentsListFileformatCategoryChanges({ batchId })
        .then((payload) => {
          for (let i = 0; i < payload.items.length; i++) {
            if (payload.items[i].batchId == batchId) {
              this.currentFileFormat = payload.items[i];
            }
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    async fetchUnknownContent(id: number) {
      this.loading = true;
      client.content
        .contentsShowBatch({ id })
        .then((payload) => {
          this.currentUnknownContent = payload;
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    storeCurrentPage(page: any) {
      this.currentPage = page;
      // console.log("222", this.currentPage);
    },

    storeCurrentPerPage(perPage: any) {
      this.currentPerPage = perPage;
      // console.log("222", this.currentPerPage);
    },

    confirm(locationName: string) {
      //   if (!this.current) return;
      //   client.package
      //     .packageConfirm({
      //       id: this.current.id,
      //       confirmRequestBody: { location: locationName },
      //     })
      //     .then((payload) => {
      //       if (!this.current) return;
      //       this.current.status =
      //         api.EnduroStoredPackageResponseBodyStatusEnum.InProgress;
      //     });
    },
    reject() {
      //   if (!this.current) return;
      //   client.package.packageReject({ id: this.current.id }).then((payload) => {
      //     if (!this.current) return;
      //     this.current.status =
      //       api.EnduroStoredPackageResponseBodyStatusEnum.InProgress;
      //   });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useContentStore, import.meta.hot));
}
